import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import axios from 'axios';
import { environment } from '../../../environments/environment';
import axiosClient from '../../../shared/axios/axios-client';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(private readonly router: Router) {}

  setToken = (tk: string) => sessionStorage.setItem('token', tk);
  getToken = () => sessionStorage.getItem('token');
  tokenIsValid = (tk?: string) => {
    const token = tk ?? this.getToken();
    return true;
  };

  getClaim(claim: string): any {
    const token = sessionStorage.getItem('token');
    if (!token) return null;

    try {
      const payloadBase64 = token.split('.')[1];
      const payloadJson = decodeURIComponent(
        escape(atob(payloadBase64.replace(/-/g, '+').replace(/_/g, '/'))),
      );
      const payload = JSON.parse(payloadJson);
      return payload[claim];
    } catch (error) {
      console.error('Error decoding JWT token:', error);
      return null;
    }
  }

  getUsuarioId(): number | null {
    return this.getClaim('id');
  }

  getUserRoles(): string[] {
    const roles = this.getClaim('role');
    if (Array.isArray(roles)) {
      return roles;
    } else if (typeof roles === 'string') {
      return [roles];
    }
    return [];
  }

  isMasterUser(): boolean {
    const roles = this.getUserRoles();
    return roles.includes('ROLE_MASTER');
  }

  getPerfil() {
    return this.getClaim('role')[0] ?? 'ROLE_SAÚDE';
  }

  isSaude() {
    return (
      this.getPerfil() === 'ROLE_SAÚDE' || this.getPerfil() === 'ROLE_SAUDE'
    );
  }

  isMaster() {
    return this.getPerfil() === 'ROLE_MASTER';
  }

  isGestor() {
    return this.getPerfil() === 'ROLE_GESTOR';
  }

  hasRole(role: string): boolean {
    return this.getPerfil() === role;
  }

  async solicitarCodigo(email: string) {
    try {
      await axios.post(`${environment.apiUrl}/auth/recovery/code`, {
        email: email,
      });

      localStorage.setItem('recovery_email', email ?? '');
    } catch (err: any) {
      throw err;
    }
  }

  async confirmarCodigo(email: string, code: string) {
    try {
      const res = await axios.post(
        `${environment.apiUrl}/auth/recovery/validate`,
        {
          email: email,
          code: code,
        },
      );

      sessionStorage.setItem('token', res.data.token);
      return res.data.token;
    } catch (err: any) {
      throw err;
    }
  }

  async redefinirSenha(password: string, token: string) {
    try {
      await axios.put(
        `${environment.apiUrl}/usuarios/senha`,
        {
          password: password,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
    } catch (err: any) {
      throw err;
    }
  }

  async definirSenhaPrimeiroAcesso(
    idUsuario: number,
    email: string,
    password: string,
  ) {
    try {
      await axiosClient.post('/auth/primeiro-acesso/definir-senha', {
        idUsuario,
        email,
        novaSenha: password,
      });

      this.router.navigate(['/auth/login']);
    } catch (err: any) {
      throw new Error(err?.response?.data?.message || 'Falha ao definir senha');
    }
  }
}
